import { inject } from '@angular/core';
import { CanActivateFn, Params } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isServerContext } from '@web/utils';
import { map } from 'rxjs';
import {
  Route,
  RouteQueryParam,
  RouteQueryParamTargetApp,
  UrlTreeProviderService,
} from '@web/common';
import { ENVIRONMENT, Environment } from '@web/config';

const getRedirectionUrlTree = (
  provider: UrlTreeProviderService,
  queryParams: Params,
  environment: Environment,
) => {
  const targetApp = queryParams[RouteQueryParam.TargetApp];
  const { RedirectToShopAfterLogin } = environment.Features;

  switch (targetApp) {
    case RouteQueryParamTargetApp.Admin:
      return getRedirectionUrlWithTarget(
        provider,
        RouteQueryParamTargetApp.Admin,
      );

    case RouteQueryParamTargetApp.Shop:
      return getRedirectionUrlWithTarget(
        provider,
        RouteQueryParamTargetApp.Shop,
      );

    default:
      if (!RedirectToShopAfterLogin.Enabled) {
        return getRedirectionUrlWithTarget(
          provider,
          RouteQueryParamTargetApp.Admin,
        );
      }

      return getRedirectionUrlWithTarget(
        provider,
        RouteQueryParamTargetApp.Shop,
      );
  }
};

const getRedirectionUrlWithTarget = (
  provider: UrlTreeProviderService,
  targetApp: RouteQueryParamTargetApp,
) => {
  return provider.urlTree(
    (provider) => provider.routerLink(Route.Redirection),
    {
      queryParams: {
        [RouteQueryParam.TargetApp]: targetApp,
      },
    },
  );
};

export const OnlyNotLoggedGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const isServer = isServerContext();
  const provider = inject(UrlTreeProviderService);
  const environment = inject(ENVIRONMENT);

  // Po stronie serwera robię tymczasowe przekierowanie na stronę ładowania.
  if (isServer) {
    return false;
  }

  return auth
    .isNotLoggedIn()
    .pipe(
      map((isNotLoggedIn) =>
        !isNotLoggedIn
          ? getRedirectionUrlTree(provider, route.queryParams, environment)
          : isNotLoggedIn,
      ),
    );
};
